module.exports = __webpack_public_path__ + "static/media/market-img5.34190a59.png";